(() => {
  const rootRoute = window.PK9_ROUTES?.root || '/';
  const route = (path) => `${rootRoute.endsWith('/') ? rootRoute : `${rootRoute}/`}${path}`;
  const productCache = new Map();
  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  });

  const money = (cents) => moneyFormatter.format(Number(cents || 0) / 100);
  const status = (message) => {
    const node = document.querySelector('[data-pk9-status]');
    if (!node) return;
    node.textContent = '';
    requestAnimationFrame(() => { node.textContent = message; });
  };

  const handleFromHref = (href) => {
    if (!href) return '';
    try {
      const match = new URL(href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const productLink = (card) => card.querySelector('.product-card__media-link, .product-card__title, a[href*="/products/"]');

  const configureButton = (button, card) => {
    if (!button || button.disabled) return;
    const link = productLink(card);
    const handle = button.dataset.productHandle || handleFromHref(button.dataset.productUrl || link?.href);
    if (!handle) return;

    button.removeAttribute('data-quick-add');
    button.removeAttribute('data-variant-id');
    button.setAttribute('data-pk9-quick-universal', '');
    button.dataset.productHandle = handle;
    button.dataset.productUrl = button.dataset.productUrl || link?.href || route(`products/${encodeURIComponent(handle)}`);
    button.textContent = 'Ajout rapide';
    card.dataset.pk9QuickReady = 'true';
  };

  const initProductCard = (card) => {
    if (!card || card.dataset.pk9QuickReady === 'true') return;
    const link = productLink(card);
    const handle = handleFromHref(link?.href);
    if (!handle) return;

    let button = card.querySelector('[data-pk9-quick-card], [data-pk9-quick-universal], [data-quick-add]');
    if (!button) {
      const media = card.querySelector('.product-card__media');
      if (!media) return;
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-card__quick pk9-quick-card';
      button.setAttribute('data-pk9-quick-card', '');
      button.dataset.productHandle = handle;
      button.dataset.productUrl = link.href;
      button.textContent = 'Ajout rapide';
      media.appendChild(button);
    }
    configureButton(button, card);
  };

  const initHomeProduct = (card) => {
    if (!card || card.dataset.pk9QuickReady === 'true') return;
    const link = productLink(card);
    const handle = handleFromHref(link?.href);
    if (!handle) return;

    let button = card.querySelector('[data-pk9-quick-universal]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'pk9n-product__quick';
      button.setAttribute('data-pk9-quick-universal', '');
      button.dataset.productHandle = handle;
      button.dataset.productUrl = link.href;
      button.textContent = 'Ajout rapide';
      card.appendChild(button);
    }
    configureButton(button, card);
  };

  const nodesIncludingSelf = (root, selector) => {
    const nodes = [];
    if (root?.matches?.(selector)) nodes.push(root);
    root?.querySelectorAll?.(selector).forEach((node) => nodes.push(node));
    return nodes;
  };

  const initButtons = (root = document) => {
    nodesIncludingSelf(root, '.product-card').forEach(initProductCard);
    nodesIncludingSelf(root, '.pk9n-product').forEach(initHomeProduct);
  };

  const getProduct = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);
    const promise = fetch(route(`products/${encodeURIComponent(handle)}.js`), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(`Product ${response.status}`);
      return response.json();
    });
    productCache.set(handle, promise);
    try {
      return await promise;
    } catch (error) {
      productCache.delete(handle);
      throw error;
    }
  };

  const planNameMap = (product) => {
    const names = new Map();
    (product.selling_plan_groups || []).forEach((group) => {
      (group.selling_plans || []).forEach((plan) => names.set(String(plan.id), plan.name || 'Formule'));
    });
    return names;
  };

  const addToCart = async (product, variant, sellingPlanId = '') => {
    const item = { id: variant.id, quantity: 1 };
    if (product.requires_selling_plan) {
      if (!sellingPlanId) throw new Error('Selling plan required');
      item.selling_plan = sellingPlanId;
    }

    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (!response.ok) throw new Error('Cart add error');
    status('Produit ajouté au panier.');
    document.querySelector('[data-cart-open]')?.click();
  };

  let quickDialog;
  let currentProduct;
  let currentSourceButton;

  const closeDialog = () => {
    if (!quickDialog) return;
    if (typeof quickDialog.close === 'function' && quickDialog.open) quickDialog.close();
    else quickDialog.removeAttribute('open');
    document.body.classList.remove('pk9-quick-open');
  };

  const getDialog = () => {
    if (quickDialog?.isConnected) return quickDialog;
    quickDialog = document.createElement('dialog');
    quickDialog.className = 'pk9-quick-dialog';
    quickDialog.setAttribute('aria-label', 'Ajout rapide au panier');
    quickDialog.innerHTML = `
      <div class="pk9-quick-dialog__inner">
        <div class="pk9-quick-dialog__top">
          <div>
            <p class="pk9-quick-dialog__kicker">AJOUT RAPIDE</p>
            <h2 data-pk9-quick-title></h2>
          </div>
          <button class="pk9-quick-dialog__close" type="button" aria-label="Fermer">×</button>
        </div>
        <div class="pk9-quick-dialog__field">
          <span>Choisissez votre variante</span>
          <select data-pk9-quick-variant aria-label="Variante"></select>
        </div>
        <div class="pk9-quick-dialog__field" data-pk9-quick-plan-wrap hidden>
          <span>Choisissez votre formule</span>
          <select data-pk9-quick-plan aria-label="Formule d’achat"></select>
        </div>
        <div class="pk9-quick-dialog__summary">
          <strong class="pk9-quick-dialog__price" data-pk9-quick-price></strong>
          <button class="pk9-quick-dialog__add" type="button" data-pk9-quick-confirm>Ajouter au panier</button>
        </div>
        <p class="pk9-quick-dialog__message" data-pk9-quick-message aria-live="polite"></p>
      </div>`;
    document.body.appendChild(quickDialog);

    quickDialog.querySelector('.pk9-quick-dialog__close')?.addEventListener('click', closeDialog);
    quickDialog.addEventListener('click', (event) => { if (event.target === quickDialog) closeDialog(); });
    quickDialog.addEventListener('close', () => document.body.classList.remove('pk9-quick-open'));

    const variantSelect = quickDialog.querySelector('[data-pk9-quick-variant]');
    variantSelect?.addEventListener('change', updateDialogSelection);
    quickDialog.querySelector('[data-pk9-quick-plan]')?.addEventListener('change', updateDialogSelection);
    quickDialog.querySelector('[data-pk9-quick-confirm]')?.addEventListener('click', confirmDialogAdd);
    return quickDialog;
  };

  const selectedVariant = () => {
    if (!currentProduct || !quickDialog) return null;
    const id = quickDialog.querySelector('[data-pk9-quick-variant]')?.value;
    return (currentProduct.variants || []).find((variant) => String(variant.id) === String(id)) || null;
  };

  function updateDialogSelection() {
    if (!quickDialog || !currentProduct) return;
    const variant = selectedVariant();
    const priceNode = quickDialog.querySelector('[data-pk9-quick-price]');
    const planWrap = quickDialog.querySelector('[data-pk9-quick-plan-wrap]');
    const planSelect = quickDialog.querySelector('[data-pk9-quick-plan]');
    const confirm = quickDialog.querySelector('[data-pk9-quick-confirm]');
    const message = quickDialog.querySelector('[data-pk9-quick-message]');
    if (!variant) return;

    let displayPrice = Number(variant.price || 0);
    if (currentProduct.requires_selling_plan) {
      const allocations = variant.selling_plan_allocations || [];
      const names = planNameMap(currentProduct);
      const previous = planSelect.value;
      planSelect.innerHTML = allocations.map((allocation, index) => {
        const id = String(allocation.selling_plan_id || '');
        const name = names.get(id) || `Formule ${index + 1}`;
        return `<option value="${id}" data-price="${Number(allocation.price || variant.price || 0)}">${name}</option>`;
      }).join('');
      if (previous && [...planSelect.options].some((option) => option.value === previous)) planSelect.value = previous;
      planWrap.hidden = allocations.length <= 1;
      const active = planSelect.selectedOptions[0];
      if (active?.dataset.price) displayPrice = Number(active.dataset.price);
      confirm.disabled = allocations.length === 0;
      message.textContent = allocations.length === 0 ? 'Cette formule doit être choisie depuis la fiche produit.' : '';
    } else {
      planWrap.hidden = true;
      planSelect.innerHTML = '';
      confirm.disabled = false;
      message.textContent = '';
    }
    priceNode.textContent = money(displayPrice);
  }

  const openVariantDialog = (product, sourceButton) => {
    currentProduct = product;
    currentSourceButton = sourceButton;
    const dialog = getDialog();
    const available = (product.variants || []).filter((variant) => variant.available);
    dialog.querySelector('[data-pk9-quick-title]').textContent = product.title || sourceButton.dataset.productTitle || 'Produit PK9';
    const variantSelect = dialog.querySelector('[data-pk9-quick-variant]');
    variantSelect.innerHTML = available.map((variant) => {
      const label = variant.title === 'Default Title' ? 'Option disponible' : variant.title;
      return `<option value="${variant.id}">${label}</option>`;
    }).join('');
    updateDialogSelection();
    document.body.classList.add('pk9-quick-open');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  async function confirmDialogAdd() {
    if (!quickDialog || !currentProduct) return;
    const variant = selectedVariant();
    const confirm = quickDialog.querySelector('[data-pk9-quick-confirm]');
    const message = quickDialog.querySelector('[data-pk9-quick-message]');
    const planSelect = quickDialog.querySelector('[data-pk9-quick-plan]');
    if (!variant || !confirm) return;

    const sellingPlanId = currentProduct.requires_selling_plan ? planSelect.value : '';
    const original = confirm.textContent;
    confirm.disabled = true;
    confirm.textContent = 'Ajout…';
    message.textContent = '';
    try {
      await addToCart(currentProduct, variant, sellingPlanId);
      confirm.textContent = 'Ajouté ✓';
      if (currentSourceButton) currentSourceButton.textContent = 'Ajouté ✓';
      setTimeout(() => {
        closeDialog();
        confirm.textContent = original;
        if (currentSourceButton) currentSourceButton.textContent = 'Ajout rapide';
        currentSourceButton = null;
      }, 450);
    } catch (_) {
      confirm.disabled = false;
      confirm.textContent = original;
      message.textContent = 'Impossible d’ajouter cette variante. Vérifiez sa disponibilité.';
      status('Impossible d’ajouter cette variante au panier.');
    }
  }

  const quickAdd = async (button) => {
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const original = 'Ajout rapide';
    button.disabled = true;
    button.textContent = 'Chargement…';
    try {
      const product = await getProduct(handle);
      const available = (product.variants || []).filter((variant) => variant.available);
      if (!available.length) {
        button.textContent = 'Épuisé';
        return;
      }

      const single = available.length === 1 ? available[0] : null;
      const allocations = single?.selling_plan_allocations || [];
      const canAddDirectly = Boolean(single) && (!product.requires_selling_plan || allocations.length === 1);

      if (canAddDirectly) {
        const planId = product.requires_selling_plan ? String(allocations[0]?.selling_plan_id || '') : '';
        button.textContent = 'Ajout…';
        await addToCart(product, single, planId);
        button.textContent = 'Ajouté ✓';
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1200);
      } else {
        button.textContent = original;
        button.disabled = false;
        openVariantDialog(product, button);
      }
    } catch (_) {
      button.textContent = 'Réessayer';
      status('Impossible de charger les options de ce produit.');
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1400);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pk9-quick-universal], [data-pk9-quick-card]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    quickAdd(button);
  }, true);

  const start = () => {
    initButtons(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initButtons(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
